import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExploreActive = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 36,
			height: 36,
			rx: 4,
			fill: "#FFF4FF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 36,
			height: 36,
			rx: 4,
			fill: "#FFF4FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.6807 16.3284C19.8772 16.0197 20.3279 16.0197 20.5244 16.3284L22.272 19.0745C22.3899 19.2597 22.5469 19.4168 22.7321 19.5346L25.4782 21.2823C25.7869 21.4788 25.7869 21.9294 25.4782 22.1259L22.7321 23.8736C22.5469 23.9914 22.3899 24.1485 22.272 24.3337L20.5244 27.0798C20.3279 27.3885 19.8772 27.3885 19.6807 27.0798L17.9331 24.3337C17.8152 24.1485 17.6581 23.9914 17.473 23.8736L14.7269 22.1259C14.4181 21.9294 14.4181 21.4788 14.7269 21.2823L17.473 19.5346C17.6581 19.4168 17.8152 19.2597 17.9331 19.0745L19.6807 16.3284Z",
			fill: "#F385FF",
			fillOpacity: .5,
			stroke: "#C948D8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.8749 12.2227C12.9917 12.0302 13.271 12.0302 13.3878 12.2227L14.2109 13.5794C14.3194 13.7582 14.4693 13.9082 14.6481 14.0166L16.0048 14.8397C16.1974 14.9565 16.1974 15.2359 16.0048 15.3527L14.6481 16.1758C14.4693 16.2842 14.3194 16.4342 14.2109 16.6129L13.3878 17.9697C13.271 18.1622 12.9917 18.1622 12.8749 17.9697L12.0518 16.6129C11.9433 16.4342 11.7934 16.2842 11.6146 16.1758L10.2579 15.3527L9.99851 15.7802L10.2579 15.3527C10.0653 15.2359 10.0653 14.9565 10.2579 14.8397L11.6146 14.0166C11.7934 13.9082 11.9433 13.7582 12.0518 13.5794L12.8749 12.2227Z",
			stroke: "#EAAFEF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.9352 8.98833C17.052 8.7958 17.3313 8.7958 17.4481 8.98832L17.7682 9.51585C17.8766 9.69461 18.0266 9.84457 18.2053 9.95302L18.7329 10.2731C18.9254 10.3899 18.9254 10.6692 18.7329 10.786L18.2053 11.1061C18.0266 11.2145 17.8766 11.3645 17.7682 11.5432L17.4481 12.0708C17.3313 12.2633 17.052 12.2633 16.9352 12.0708L16.6151 11.5432C16.5067 11.3645 16.3567 11.2145 16.178 11.1061L15.6504 10.786L15.3911 11.2135L15.6504 10.786C15.4579 10.6692 15.4579 10.3899 15.6504 10.2731L16.178 9.95302C16.3567 9.84457 16.5067 9.69461 16.6151 9.51585L16.9352 8.98833Z",
			stroke: "#C948D8"
		})
	]
});
export default SvgExploreActive;
